<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="roadAreaCode" label="路区代码" :rules="[{ required: true, message: '请选择' }]" >
        <RoadAreaSelect v-model:value="editForm.roadAreaCode" allowClear mode="multiple" />
      </a-form-item>
      <a-form-item name="employeeNo" label="查看人" :rules="[{ required: true, message: '请选择' }]" >
        <user-select v-model:value="editForm.employeeNo" allowClear />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, h } from 'vue'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import {
  createRoadAreaConfig,
  updateRoadAreaConfig
} from '@/api/yuntuSales/roadAreaConfig'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref({})
const emit = defineEmits(['success'])
const toggle = (row?: any) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = { ...editForm.value }
    try {
      if (editForm.value.id) {
        await updateRoadAreaConfig(p)
      } else {
        await createRoadAreaConfig(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  align-items: center;
  .title-span {
    font-weight: 500;
    color: red;
    font-size: 14px;
  }
}
</style>
